'use client'

import * as HoverCardPrimitive from '@radix-ui/react-hover-card'
import { cn } from '@repo/ui/lib/utils'
import { ComponentProps, createContext, useContext, useState } from 'react'

const HoverContext = createContext<{
  open: boolean
  setOpen: (value: boolean) => void
}>({
  open: false,
  setOpen: () => {},
})

function HoverCard({ open: defaultOpen = false, ...props }: ComponentProps<typeof HoverCardPrimitive.Root>) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <HoverContext.Provider value={{ open, setOpen }}>
      <HoverCardPrimitive.Root data-slot='hover-card' open={open} onOpenChange={setOpen} openDelay={0} closeDelay={0} {...props} />
    </HoverContext.Provider>
  )
}

function HoverCardTrigger({ ...props }: ComponentProps<typeof HoverCardPrimitive.Trigger>) {
  const { setOpen } = useContext(HoverContext)

  const handleTouchStart = () => {
    setOpen(true)
  }

  return <HoverCardPrimitive.Trigger data-slot='hover-card-trigger' onTouchStart={handleTouchStart} {...props} />
}

function HoverCardContent({ className, align = 'start', sideOffset = 0, ...props }: ComponentProps<typeof HoverCardPrimitive.Content>) {
  return (
    <HoverCardPrimitive.Portal data-slot='hover-card-portal'>
      <HoverCardPrimitive.Content
        data-slot='hover-card-content'
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-hover-card-content-transform-origin) outline-hidden z-50 w-fit pt-px',
          className,
        )}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  )
}

export { HoverCard, HoverCardContent, HoverCardTrigger }
